<article class="h-100 d-flex flex-column">
	<section class="container d-flex flex-column flex-grow-1">
		<div #cardContainer class="mb-4 align-self-center" style="z-index: 0;"></div>
		<form 
			[formGroup]="cardForm" 
			class="card-form mx-3 d-flex flex-column flex-grow-1"
			(ngSubmit)="onSubmit()"
		>	
			<div class="row">
				<mat-form-field class="cc-field" subscriptSizing="dynamic">
					<mat-label>Número de tarjeta</mat-label>
					<input 
						#numberInput
						matInput
						formControlName="number"
						required="false"
						(input)="restrictCardNumberInput($event)"
						maxlength="19"
						inputmode="numeric"
					>
					<input #numberHiddenInput id="numberHidden" class="visually-hidden-input" tabindex="-1" aria-hidden="true">
					<mat-error>
						<span class="material-symbols-rounded">cancel</span>
						{{ getCardNumberErrorMessage() }}
					</mat-error>
				</mat-form-field>
			</div>
			

			<mat-grid-list cols="2" rowHeight="110px">
				<mat-grid-tile>
					<mat-form-field class="cc-field me-2 w-100">
						<mat-label>Fecha de exp.</mat-label>
						<input 
							#expiryInput
							matInput
							formControlName="expiry"
							required="false"
							(input)="restrictExpiryInput($event)" 
							maxlength="7"
							inputmode="numeric"
						>
						<input #expiryHiddenInput id="expiryHidden" hidden>
						<mat-error>
							<span class="material-symbols-rounded">cancel</span>
							{{ getExpiryDateErrorMessage() }}
						</mat-error>
					</mat-form-field>
				</mat-grid-tile>
				<mat-grid-tile>
					<mat-form-field class="cc-field ms-2 w-100">
						<mat-label>CVV</mat-label>
						<div class="cvc-field-wrapper position-relative">
							<input
								#cvcInput
								matInput
								formControlName="cvc"
								required="false"
								maxlength="3"
								minlength="3"
								inputmode="numeric"
								enterkeyhint="next"
								(keydown.enter)="handleEnterKeyOnCvc($event)"
								(blur)="onCvcBlur()"
								(focus)="onCvcFocus()"
								[style.color]="showCvc ? 'inherit' : 'transparent'"
							>
							<div *ngIf="!showCvc" class="cvc-mask position-absolute">
								{{ getMaskedCvc() }}
							</div>
						</div>
						<button 
							matSuffix 
							class="cc-btn me-2"
							(pointerdown)="toggleCvcMask($event)" 
							(click)="$event.preventDefault()"
							[attr.aria-label]="'Hide CVV'" 
							[attr.aria-pressed]="!showCvc"
						>
							<span class="material-symbols-rounded" style="top: unset !important;">{{ showCvc ? 'visibility' : 'visibility_off' }}</span>
						</button>
						<mat-error>
							<span class="material-symbols-rounded">cancel</span>
							CVV inválido.
						</mat-error>
						<mat-hint align="start" (click)="cvvTooltip.tooltip.toggle()" style="cursor: pointer;">
							<app-custom-tooltip
								#cvvTooltip
								[tooltipInfo]="tooltipInfo"
								[tooltipTitle]="tooltipTitle"
							></app-custom-tooltip>
							¿Qué es el CVV?
						</mat-hint>
					</mat-form-field>
				</mat-grid-tile>
			</mat-grid-list>

			<div class="row mb-3">
				<mat-form-field class="cc-field">
					<mat-label>Nombre del titular</mat-label>
					<input 
						#nameInput
						matInput
						formControlName="name"
						[errorStateMatcher]="showOnDirtyErrorStateMatcher"
						required="false"
						maxlength="26"
						enterkeyhint="done"
						(keydown.enter)="handleEnterKeyOnName($event)"
						(input)="CardFormHelper.iOSNameInputCorrection($event)"
					>
					<mat-error>
						<span class="material-symbols-rounded">cancel</span>
						{{ getCardHolderNameErrorMessage() }}
					</mat-error>
				</mat-form-field>
			</div>

			<div class="row w-100 mx-auto mt-auto mb-4">
				<button 
					type="submit" 
					class="cc-submit-btn"
					mat-flat-button 
					[disabled]="!cardForm.valid || isLoading"
				>
					Guardar tarjeta
				</button>
			</div>
		</form>
	</section>
</article>